import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { ToastContainer } from 'components/dependencies/Toast'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { App } from './App'
import configureStore from './configureStore'
import { BrowserRouter } from 'react-router-dom'
import * as Buffer from 'buffer'
window.Buffer = Buffer.Buffer
import 'index.css'
import * as serviceWorker from './serviceWorker'

const store = configureStore()

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<ToastContainer />
			<App />
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
